export default {
	data: {
		selectedImageIndex: undefined,
		openstreetmap: false
	},
	beforeMount: function () {

		this.checkOsmConsent();

		var url = new URL(window.location.href);
		var params = {};
		for (let key of url.searchParams.keys()) {
			params[key] = url.searchParams.get(key);

		}
		this.searchParams = params;
	},

	mounted: function () {
		window.addEventListener('ccm19WidgetClosed', (event) => {
			this.checkOsmConsent();
		});


		//facility images carousel
		if ($('.facility-slide').length > 0) {

			$(".owl-carousel.facility-slide").each(function () {

				//Remove all slides except the first 3

				const maxSlides = 3;
				$(this).children().slice(maxSlides).remove();


				// For example, remove only the slides at index 1 and 3
				/*	$(this).children().each(function (index) {
						if (index === 1 || index === 3) {
							$(this).remove();
						}
					}); */

			});


			$(".owl-carousel.facility-slide").owlCarousel({
				items: 1,
				loop: false,
				rewind: true,
				autoplay: true,
				dots: false,
				smartSpeed: 2000,
				lazyLoad: true,
				animateOut: 'fadeOut',
				nav: false
			});

			this.setupCarouselToggle('.carousel-button-facility');

		}
	},
	computed: {

		mailto: function () {
			return `mailto:${this.emailAddress}`;
		},
		emailAddress: function () {
			return (VOFFICE.contactEmail || ['website', 'v-office.com']).join('@');
		},
		phoneLink: function () {
			if (VOFFICE.phoneLink) {
				var el = document.getElementById('preloader');

				window.location.href = VOFFICE.phoneLink;
				if (el) {
					el.style.display = "none";
				}
			}
		},
		phoneView: function () {
			if (VOFFICE.phoneView) {
				return VOFFICE.phoneView;
			}
		},
		mailto2: function () {
			return `mailto:${this.emailAddress2}`;
		},
		emailAddress2: function () {
			return (VOFFICE.contactEmail2 || ['website', 'v-office.com']).join('@');
		},
		phoneLink2: function () {
			if (VOFFICE.phoneLink2) {
				var el = document.getElementById('preloader');

				window.location.href = VOFFICE.phoneLink2;
				if (el) {
					el.style.display = "none";
				}
			}
		},
		phoneView2: function () {
			if (VOFFICE.phoneView2) {
				return VOFFICE.phoneView2;
			}
		}
	},
	methods: {

		setupCarouselToggle: function (buttonSelector) {

			$(buttonSelector).each(function () {
				var button = $(this);
				var targetSelector = button.data('target');
				var carousel = $(targetSelector);
				var isPlaying = true;

				// Carousel ggf. initialisieren (falls noch nicht geschehen)
				if (!carousel.hasClass('owl-loaded')) {
					carousel.owlCarousel({
						items: 1,
						loop: true,
						autoplay: true,
						dots: false,
						smartSpeed: 2000,
						lazyLoad: true,
						animateOut: 'fadeOut',
						nav: false,
						autoplayHoverPause: false
					});
				}

				// Umschaltfunktion
				function toggleCarousel() {
					if (isPlaying) {
						carousel.trigger('stop.owl.autoplay');
						button.find('.pause').hide();
						button.find('.play').show();
						button.attr('aria-pressed', 'false');
					} else {
						carousel.trigger('play.owl.autoplay', [3000]);
						button.find('.play').hide();
						button.find('.pause').show();
						button.attr('aria-pressed', 'true');
					}
					isPlaying = !isPlaying;
				}

				// Klick
				button.on('click', toggleCarousel);

				// Tastatur (Enter, Space)
				button.on('keydown', function (e) {
					if (e.key === ' ' || e.key === 'Enter' || e.keyCode === 32 || e.keyCode === 13) {
						e.preventDefault(); // Verhindert Scrollen bei Space
						toggleCarousel();
					}
				});

				// Zugänglichkeit: Button als toggle markieren
				button.attr('role', 'button');
				button.attr('aria-pressed', 'true');
			});

		},

		scrollIntoView: function (id) {
			let el = document.getElementById(id);
			if (el) {
				el.scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				});
			}

		},

		searchTab: function () {

			document.getElementById('obj-tab').classList.remove('active');
			document.getElementById('search-tab').classList.remove('active');
			document.getElementById('search-obj-form').style.display = 'none';
			document.getElementById('search-form').style.display = 'flex';
			document.getElementById('search-tab').classList.add('active');

		},
		objectTab: function () {

			document.getElementById('obj-tab').classList.remove('active');
			document.getElementById('search-tab').classList.remove('active');
			document.getElementById('search-form').style.display = 'none';
			document.getElementById('search-obj-form').style.display = 'flex';
			document.getElementById('obj-tab').classList.add('active');

		},

		checkOsmConsent: function () {
			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			var cookieName = 'allowOpenstreetmap_' + suffix;
			const allowOpenstreet = this.getCookie(cookieName);
			if (allowOpenstreet) {
				this.openstreetmap = true;
			} else {
				const data = CCM.acceptedEmbeddings;
				const targetName = "OpenStreetMap";
				const entry = data.find(item => item.name === targetName);

				if (entry) {
					this.openstreetmap = true;
				} else {
					this.openstreetmap = false;
				}
			}
		},

		getCookie: function (name) {
			const nameEQ = name + "=";
			const ca = document.cookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) === ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		},

		setCookie: function (name, value, days) {
			const date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			const expires = "expires=" + date.toUTCString();
			document.cookie = name + "=" + value + ";" + expires + ";path=/";
		},

		allowOpenstreetmap: function () {
			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			var cookieName = 'allowOpenstreetmap_' + suffix;
			this.setCookie(cookieName, true, VOFFICE.settings.osmCookieDays);
			this.openstreetmap = true;
		},

		showOpenstreetmap: function () {
			this.openstreetmap = true;
		},

		getUnitSearchTarget: function (id) {
			return 'unit_' + id;
		},

		unitImages: function (string) {
			//console.log(string);
		}


	},

};